import validator from "validator";

export const EMAIL = (email) => !email || validator.isEmail(email);
